import React, { useState, useEffect, forwardRef } from "react";
import PT from "prop-types";
import BasePhoneInput from "react-phone-number-input/input";

const SUPPORTED_PHONE_LOCALES = [
  "de",
  "el",
  "en",
  "es",
  "fi",
  "fr",
  "it",
  "nb",
  "pl",
  "pt",
  "ru",
  "sv",
  "ua",
  "vi",
];
const PhoneInput = forwardRef((props, ref) => {
  const [locale, setLocale] = useState(undefined);
  useEffect(() => {
    async function foo() {
      if (
        props.locale === "en" ||
        !SUPPORTED_PHONE_LOCALES.includes(props.locale)
      ) {
        setLocale(undefined);
      } else {
        const { default: module } = await import(
          /* webpackChunkName: "react-phone-number-input-locale" */

          /* webpackMode: "lazy" */
          `react-phone-number-input/locale/${props.locale}`
        );
        setLocale(module);
      }
    }
    foo();
  }, [props.locale]);
  return <BasePhoneInput ref={ref} labels={locale} {...props} international />;
});
PhoneInput.displayName = "PhoneInput";
PhoneInput.propTypes = {
  locale: PT.string,
};
PhoneInput.defaultProps = {
  locale: "ru",
};

export default PhoneInput;
